/* How Knowledge prints sizes and counts. */

/** Binary units, as a drive shows them: 8,346,772 bytes is 8.0 MB. */
export function formatSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  const units = ["KB", "MB", "GB", "TB"];
  let value = bytes / 1024;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit += 1;
  }
  return `${unit === 0 && value >= 10 ? Math.round(value) : value.toFixed(1)} ${units[unit]}`;
}

const compactFormat = new Intl.NumberFormat("en-US", { notation: "compact", maximumFractionDigits: 1 });
/** 37,530 → "37.5K". */
export const compact = (n: number) => compactFormat.format(n);

/** "3 files", "1 file". */
export const plural = (n: number, noun: string) => `${n.toLocaleString("en-US")} ${noun}${n === 1 ? "" : "s"}`;

/** The extension a file name ends in, lower-cased, or "" when it has none. */
export const extOf = (name: string) => (name.includes(".") ? name.split(".").pop()!.toLowerCase() : "");
